import { observer } from 'mobx-react';
import React from 'react';

import MediaTypography from 'components/MediaTypography';
import store from 'store';

import GoldCrownIcon from '@common/assets/icons/gold-crown.svg';

import ChangePassword from '../ChangePassword';
import ProfileAvatar from './Avatar';
import * as Styled from './style';

function AvatarUserData() {
	return (
		<Styled.ContentBox>
			<ProfileAvatar />
			<Styled.SubWrap>
				<Styled.MarginDiv>
					<MediaTypography variant="h4" lineClamp={{ default: 1 }}>
						{store.profile.fullName}
					</MediaTypography>
					{store.profile?.partner?.is_premium ? (
						<GoldCrownIcon style={{ marginTop: '3px', width: '22px', height: '20px' }} />
					) : null}
				</Styled.MarginDiv>
			</Styled.SubWrap>
			<Styled.MarginDiv>
				<ChangePassword />
			</Styled.MarginDiv>
		</Styled.ContentBox>
	);
}

export default observer(AvatarUserData);
